import makeStyles from '@mui/styles/makeStyles';

const sectionStyle = (isVideoEnabled: boolean, isSharingScreen: boolean) =>
  makeStyles((theme) => ({
    mainSection: {
      height: isVideoEnabled || isSharingScreen ? "calc(100vh - 277px)" : "calc(100vh - 147px)",
      margin: "8px 6px 0px 6px",
      background: "transparent",
      padding: "0 0 12px",
      marginTop: "-48px",
      borderRadius: 8,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      "& div[role=tablist]": {
        "& div": {
          display: "none",
        },
        "& div[role=tabpanel]": {
          borderBottom: "none",
        },
      },
    },
    communicationWrapper: {
      marginTop: 8,
      backgroundColor: "#fff",
      borderRadius: 12,
      width: "100%",
      padding: "1rem",
      height: isVideoEnabled || isSharingScreen ? "calc(100vh - 325px)" : "calc(100vh - 196px)",
    },
    communicationHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& span.title": {
        color: "#344054",
        font: "700 16px/24px Manrope",
      },
    },
    communcationCloseIcon: {
      cursor: "pointer",
    },
  }));

export default sectionStyle;
